import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptor,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';
import { MSALInstanceFactory, MSALGuardConfigFactory } from './app/configs/auth-config';
import { provideStore } from '@ngrx/store';
import { appReducer } from '@app/state/reducers/app.reducer';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { authInterceptor } from '@app/interceptors/auth.interceptor';
import { BottlerInterceptor } from '@app/interceptors/bottler.interceptor';
import { provideZoneChangeDetection } from '@angular/core';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(
      // DI-based interceptors must be explicitly enabled.
      withInterceptorsFromDi(),
    ),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: BottlerInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideStore({
      app: appReducer,
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideZoneChangeDetection(),
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        background: '#f2eded',
        'margin-bottom': '0px',
      },
    }),
    provideIonicAngular(),
    provideToastr(),
    provideAnimations(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useValue: {
        interactionType: 'redirect',
        protectedResourceMap: new Map([['https://graph.microsoft.com/v1.0/me', ['user.read']]]),
      },
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService, // Add this line to provide the service
  ],
}).catch((err) => console.error(err));
